import { getDimmedTextColor, createStyleFunction } from 'utils/ui';
var textTransformMap = {
  all: 'uppercase',
  first: 'capitalize',
  none: 'none'
};
export var textPropsDef = [{
  styleProp: 'fontSize',
  properties: ['fontSize'],
  getValue: function getValue(size, theme) {
    return theme.globals.typeScale[size] || size;
  }
}, {
  styleProp: 'bold',
  properties: ['fontWeight'],
  getValue: function getValue(bold) {
    return bold ? 'bold' : 'normal';
  }
}, {
  styleProp: 'fontWeight',
  properties: ['fontWeight'],
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'textAlign',
  properties: ['textAlign'],
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'lineHeight',
  properties: ['lineHeight'],
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'caps',
  properties: ['textTransform'],
  getValue: function getValue(caps) {
    return textTransformMap[caps];
  }
}, {
  styleProp: 'dimmed',
  properties: ['color'],
  getValue: function getValue(dimmed, theme) {
    return dimmed ? getDimmedTextColor(theme) : theme.text;
  }
}, {
  styleProp: 'verticalAlign',
  getValue: function getValue(value) {
    return value;
  }
}];
export default createStyleFunction(textPropsDef);